import React, { useEffect, useState } from 'react';
import '../styles/AuthPages.css';

const AuthCallbackPage = ({ headline = "Continue in the app" }) => {
  const [deepLinkUrl, setDeepLinkUrl] = useState('');

  useEffect(() => {
    // SECURITY: Capture URL fragments IMMEDIATELY before PostHog or any other script can access them
    const hash = window.location.hash;
    const search = window.location.search;
    
    // CRITICAL FIX: Browsers strip hash fragments when navigating to custom protocols
    // Convert hash parameters to query parameters for deep link
    let finalSearch = search;
    
    if (hash && hash.length > 1) {
      // Parse hash fragment (remove leading #)
      const hashParams = hash.substring(1);
      
      // Combine with existing query params
      if (search && search.length > 1) {
        // Already has query params, append hash params
        finalSearch = `${search}&${hashParams}`;
      } else {
        // No query params yet, use hash params as query
        finalSearch = `?${hashParams}`;
      }
    }
    
    // Build deep link with hash params converted to query params
    const targetUrl = `marketsentinel://auth/callback${finalSearch}`;
    setDeepLinkUrl(targetUrl);
    
    // Attempt automatic redirect
    window.location.href = targetUrl;
  }, []);

  const handleOpenApp = () => {
    if (deepLinkUrl) {
      window.location.href = deepLinkUrl;
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-content">
          <h1 className="auth-title">{headline}</h1>
          
          <button className="btn-primary auth-primary-btn" onClick={handleOpenApp}>
            Open Market Sentinel
          </button>
          
          <p className="auth-note">
            If the app doesn't open, open this link on the phone where Market Sentinel is installed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
